import { render, staticRenderFns } from "./AccessibilityClientStats.vue?vue&type=template&id=032aa1a5&scoped=true&"
import script from "./AccessibilityClientStats.vue?vue&type=script&lang=js&"
export * from "./AccessibilityClientStats.vue?vue&type=script&lang=js&"
import style0 from "./accessibility-stats.css?vue&type=style&index=0&id=032aa1a5&scoped=true&lang=css&"
import style1 from "./AccessibilityClientStats.vue?vue&type=style&index=1&id=032aa1a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032aa1a5",
  null
  
)

export default component.exports